import React, { useEffect, useState } from "react";
import CommonTable from "../../common-components/common-tables/CommonTable";
import { formatDateTime } from "../../common-data/Converts";
import { CallIcon, EmailIcon, PersonIcon } from "../../../images/icons/icons";

const TrainerNotificationLogsTable = ({
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  trainerNotificationLogs,
  trainerNotificationLogsLoading,
}) => {
  const iniTbDatas = {
    pagination: [],
    allData: [],
  };
  const [allDatas, setAllDatas] = useState(iniTbDatas);

  useEffect(() => {
    if (
      !trainerNotificationLogsLoading &&
      trainerNotificationLogs?.status &&
      trainerNotificationLogs?.data?.length > 0
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: trainerNotificationLogs.data,
        pagination:
          trainerNotificationLogs?.pagination?.length > 0
            ? trainerNotificationLogs.pagination
            : [],
      }));
    } else {
      setAllDatas(iniTbDatas);
    }
  }, [trainerNotificationLogsLoading, trainerNotificationLogs]);

  const tbColumns = [
    {
      dataField: "trainer_name",
      text: "trainer Info",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <PersonIcon />
              </span>{" "}
              <span className="tb-data">{row?.trainer_name || "NA"}</span>
            </div>

            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <CallIcon />
              </span>{" "}
              <span className="tb-data">{row?.user_contact || "NA"}</span>
            </div>

            {row?.trainer_email && (
              <div className="tb-flex">
                <span className="tb-data tb-info-icon">
                  <EmailIcon />
                </span>
                <span className="tb-data lowercase">{row?.trainer_email}</span>
              </div>
            )}
          </div>
        );
      },
    },
    // {
    //   dataField: "gym_name",
    //   text: "Gym Name",
    //   formatter: (_, row) => {
    //     return <span className="tb-data">{row?.gym_name || "NA"}</span>;
    //   },
    // },
    {
      dataField: "broadcast_name",
      text: "Broadcast",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <span className="tb-data">{row?.broadcast_name?.replace(/_/g, " ") || "NA"}</span>
            {row?.template_name && (
              <span className="tb-data">{row.template_name?.replace(/_/g, " ")}</span>
            )}
          </div>
        );
      },
    },
    {
      dataField: "notification_type",
      text: "Type",
      formatter: (_, row) => {
        const isWhatsapp = row?.is_whatsapp;
        const isEmail = row?.is_email;
        const isPush = row?.is_push;

        return (
          <div className="tb-flex-col">
            {isWhatsapp && <span className="tb-data tb-badge tb-badge-success">WhatsApp</span>}
            {isEmail && <span className="tb-data tb-badge tb-badge-success-1">Email</span>}
            {isPush && <span className="tb-data tb-badge tb-badge-success-2">Push</span>}
          </div>
        );
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (_, row) => {
        const status = row?.status?.toLowerCase();
        const statusClass =
          status === "sent"
            ? "tb-badge-success"
            : status === "failed"
            ? "not-assigned"
            : status === "pending"
            ? "tb-badge-warning"
            : "tb-badge";
        return (
          <span className={`tb-data tb-badge ${statusClass}`}>{status}</span>
        );
      },
    },
    {
      dataField: "error",
      text: "Error",
      formatter: (_, row) => {
        return (
          <span className="tb-data" title={row?.error || ""}>
            {row?.error ? row.error.substring(0, 50) + "..." : "-"}
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.date_added ? formatDateTime(row.date_added) : "NA"}
          </span>
        );
      },
    },
  ];

  return (
    <div className="common-table-container">
      <CommonTable
        tableData={allDatas.allData}
        tablePagination={allDatas.pagination}
        tableColumns={tbColumns}
        isPage={isPage}
        setIsPage={setIsPage}
        pageLimit={pageLimit}
        setPageLimit={setPageLimit}
        isLoading={trainerNotificationLogsLoading}
      />
    </div>
  );
};

export default TrainerNotificationLogsTable;
